import React, { FC } from 'react';
import { DashboardHeaderLayout } from './components';
import {
  DashboardHeaderInfoSkeleton,
  ObjectiveListSkeleton,
} from './components/skeletons';

export const DashboardHeaderLoading: FC = () => {
  return (
    <DashboardHeaderLayout>
      <DashboardHeaderInfoSkeleton />
      <ObjectiveListSkeleton />
    </DashboardHeaderLayout>
  );
};
